module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c9eb9a25b468d850aef34ad1bcf04d8f.png";